// This file was auto-generated by Fern from our API Definition.
const WebSocketMessageOriginValues = {
    Client: "client",
    Server: "server",
};
export const WebSocketMessageOrigin = Object.assign(Object.assign({}, WebSocketMessageOriginValues), { _visit: (value, visitor) => {
        switch (value) {
            case WebSocketMessageOrigin.Client:
                return visitor.client();
            case WebSocketMessageOrigin.Server:
                return visitor.server();
            default:
                return visitor._other();
        }
    } });
